/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _module_registration__why_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Pourquoi utiliser [b]Go Africa Online[/b] ?' }],
    'fr',
);

export function module_registration__why(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__why_fr.format(args) as unknown as string;
    }

    return _module_registration__why_fr.format(args) as unknown as string;
}

const _module_registration__you_are_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vous êtes' }],
    'fr',
);

export function module_registration__you_are(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__you_are_fr.format(args) as unknown as string;
    }

    return _module_registration__you_are_fr.format(args) as unknown as string;
}

const _module_registration__choice_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Un professionnel' }],
    'fr',
);

export function module_registration__choice_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__choice_pro_fr.format(args) as unknown as string;
    }

    return _module_registration__choice_pro_fr.format(args) as unknown as string;
}

const _module_registration__choice_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Une société' }],
    'fr',
);

export function module_registration__choice_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__choice_company_fr.format(args) as unknown as string;
    }

    return _module_registration__choice_company_fr.format(args) as unknown as string;
}

const _module_registration__find_clients_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Trouvez vos futurs clients' }],
    'fr',
);

export function module_registration__find_clients(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__find_clients_fr.format(args) as unknown as string;
    }

    return _module_registration__find_clients_fr.format(args) as unknown as string;
}

const _module_registration__sell_products_services_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vendez vos produits et services' }],
    'fr',
);

export function module_registration__sell_products_services(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__sell_products_services_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__sell_products_services_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__promote_brand_image_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Diffusez votre image de marque' }],
    'fr',
);

export function module_registration__promote_brand_image(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__promote_brand_image_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__promote_brand_image_fr.format(args) as unknown as string;
}

const _module_registration__access_local_talents_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Accédez à un vivier de talents locaux' }],
    'fr',
);

export function module_registration__access_local_talents(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__access_local_talents_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__access_local_talents_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__create_community_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Créez votre propre communauté' }],
    'fr',
);

export function module_registration__create_community(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__create_community_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__create_community_fr.format(args) as unknown as string;
}

const _module_registration__digitalize_communication_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Digitalisez votre communication' }],
    'fr',
);

export function module_registration__digitalize_communication(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__digitalize_communication_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__digitalize_communication_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__present_online_profile_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Présentez votre profil en ligne' }],
    'fr',
);

export function module_registration__present_online_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__present_online_profile_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__present_online_profile_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__share_professional_info_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Diffusez de l’information pro' }],
    'fr',
);

export function module_registration__share_professional_info(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__share_professional_info_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__share_professional_info_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__build_subscriber_group_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Constituez vous un groupe d’abonnés' }],
    'fr',
);

export function module_registration__build_subscriber_group(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__build_subscriber_group_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__build_subscriber_group_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__attract_decision_makers_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Faites vous remarquer des décideurs' }],
    'fr',
);

export function module_registration__attract_decision_makers(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__attract_decision_makers_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__attract_decision_makers_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__apply_job_postings_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Postulez pour les annonces d’emploi' }],
    'fr',
);

export function module_registration__apply_job_postings(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__apply_job_postings_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__apply_job_postings_fr.format(args) as unknown as string;
}

const _module_registration__follow_sector_news_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Suivez l’information des secteurs qui vous intéressent' }],
    'fr',
);

export function module_registration__follow_sector_news(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__follow_sector_news_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__follow_sector_news_fr.format(args) as unknown as string;
}

const _module_registration__join_free_millions_members_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Rejoignez gratuitement des [b]millions de membres et d’entreprises africaines[/b]',
        },
    ],
    'fr',
);

export function module_registration__join_free_millions_members(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__join_free_millions_members_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__join_free_millions_members_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__first_name_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Prénom' }],
    'fr',
);

export function module_registration__first_name(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__first_name_fr.format(args) as unknown as string;
    }

    return _module_registration__first_name_fr.format(args) as unknown as string;
}

const _module_registration__last_name_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nom' }],
    'fr',
);

export function module_registration__last_name(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__last_name_fr.format(args) as unknown as string;
    }

    return _module_registration__last_name_fr.format(args) as unknown as string;
}

const _module_registration__email_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Email' }],
    'fr',
);

export function module_registration__email(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__email_fr.format(args) as unknown as string;
    }

    return _module_registration__email_fr.format(args) as unknown as string;
}

const _module_registration__password_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mot de passe' }],
    'fr',
);

export function module_registration__password(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__password_fr.format(args) as unknown as string;
    }

    return _module_registration__password_fr.format(args) as unknown as string;
}

const _module_registration__register_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Souhaitez-vous également inscrire une société ?' }],
    'fr',
);

export function module_registration__register_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__register_company_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__register_company_fr.format(args) as unknown as string;
}

const _module_registration__i_accept_fr = new IntlMessageFormat(
    [{ type: 0, value: "J'accepte les" }],
    'fr',
);

export function module_registration__i_accept(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__i_accept_fr.format(args) as unknown as string;
    }

    return _module_registration__i_accept_fr.format(args) as unknown as string;
}

const _module_registration__cgu_fr = new IntlMessageFormat(
    [{ type: 0, value: 'conditions générales d’utilisation' }],
    'fr',
);

export function module_registration__cgu(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__cgu_fr.format(args) as unknown as string;
    }

    return _module_registration__cgu_fr.format(args) as unknown as string;
}

const _module_registration__create_account_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Je créé mon compte' }],
    'fr',
);

export function module_registration__create_account(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__create_account_fr.format(args) as unknown as string;
    }

    return _module_registration__create_account_fr.format(args) as unknown as string;
}

const _module_superapp__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Une [b]super app[/b] professionnelle et multi-services' }],
    'fr',
);

export function module_superapp__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__title_fr.format(args) as unknown as string;
    }

    return _module_superapp__title_fr.format(args) as unknown as string;
}

const _module_superapp__app_entreprises_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Entreprises' }],
    'fr',
);

export function module_superapp__app_entreprises(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_entreprises_fr.format(args) as unknown as string;
    }

    return _module_superapp__app_entreprises_fr.format(args) as unknown as string;
}

const _module_superapp__app_professionnels_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Professionnels' }],
    'fr',
);

export function module_superapp__app_professionnels(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_professionnels_fr.format(args) as unknown as string;
    }

    return _module_superapp__app_professionnels_fr.format(args) as unknown as string;
}

const _module_superapp__app_reseau_social_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Réseau social' }],
    'fr',
);

export function module_superapp__app_reseau_social(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_reseau_social_fr.format(args) as unknown as string;
    }

    return _module_superapp__app_reseau_social_fr.format(args) as unknown as string;
}

const _module_superapp__app_messagerie_privee_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Messagerie privée' }],
    'fr',
);

export function module_superapp__app_messagerie_privee(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_messagerie_privee_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_superapp__app_messagerie_privee_fr.format(args) as unknown as string;
}

const _module_superapp__app_emploi_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Emploi' }],
    'fr',
);

export function module_superapp__app_emploi(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_emploi_fr.format(args) as unknown as string;
    }

    return _module_superapp__app_emploi_fr.format(args) as unknown as string;
}

const _module_superapp__app_medias_articles_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Médias / Articles' }],
    'fr',
);

export function module_superapp__app_medias_articles(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_medias_articles_fr.format(args) as unknown as string;
    }

    return _module_superapp__app_medias_articles_fr.format(args) as unknown as string;
}

const _module_gao_presentation__members_fr = new IntlMessageFormat(
    [{ type: 0, value: 'membres' }],
    'fr',
);

export function module_gao_presentation__members(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__members_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__members_fr.format(args) as unknown as string;
}

const _module_gao_presentation__businesses_fr = new IntlMessageFormat(
    [{ type: 0, value: 'entreprises' }],
    'fr',
);

export function module_gao_presentation__businesses(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__businesses_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__businesses_fr.format(args) as unknown as string;
}

const _module_gao_presentation__page_views_fr = new IntlMessageFormat(
    [{ type: 0, value: 'pages vues / mois' }],
    'fr',
);

export function module_gao_presentation__page_views(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__page_views_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__page_views_fr.format(args) as unknown as string;
}

const _module_gao_presentation__visitors_per_year_fr = new IntlMessageFormat(
    [{ type: 0, value: 'de visiteurs / an' }],
    'fr',
);

export function module_gao_presentation__visitors_per_year(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__visitors_per_year_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_gao_presentation__visitors_per_year_fr.format(
        args,
    ) as unknown as string;
}

const _module_gao_presentation__new_joiners_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ils viennent de nous rejoindre' }],
    'fr',
);

export function module_gao_presentation__new_joiners(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__new_joiners_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__new_joiners_fr.format(args) as unknown as string;
}

const _module_gao_presentation__network_africa_fr = new IntlMessageFormat(
    [{ type: 0, value: "Entrez dans le plus grand réseau professionnel d'Afrique !" }],
    'fr',
);

export function module_gao_presentation__network_africa(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__network_africa_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_gao_presentation__network_africa_fr.format(args) as unknown as string;
}

const _module_gao_presentation__register_fr = new IntlMessageFormat(
    [{ type: 0, value: "S'inscrire" }],
    'fr',
);

export function module_gao_presentation__register(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__register_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__register_fr.format(args) as unknown as string;
}

const _module_gao_presentation__title_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Nous ne créons pas seulement des connexions [b]Nous bâtissons des opportunités[/b]',
        },
    ],
    'fr',
);

export function module_gao_presentation__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__title_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__title_fr.format(args) as unknown as string;
}

const _module_gao_presentation__text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Chez Go Africa Online, nous pensons que le développement du\ncontinent Africain passe par une progression des affaires\nréalisées par les acteurs économiques locaux. Internet, les\ninteractions sociales, l’intelligence artificielle : découvrez\ncomment nos services peuvent transformer vos affaires.\nRejoignez la communauté florissante d'entrepreneurs africains\nqui, grâce à nos services innovants, écrivent leur succès.",
        },
    ],
    'fr',
);

export function module_gao_presentation__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__text_fr.format(args) as unknown as string;
    }

    return _module_gao_presentation__text_fr.format(args) as unknown as string;
}

const _module_gao_presentation__shape_future_fr = new IntlMessageFormat(
    [{ type: 0, value: "Ensemble, façonnons l'avenir du continent" }],
    'fr',
);

export function module_gao_presentation__shape_future(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__shape_future_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_gao_presentation__shape_future_fr.format(args) as unknown as string;
}

const _module_references__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Il nous font [b]confiance[/b]' }],
    'fr',
);

export function module_references__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_references__title_fr.format(args) as unknown as string;
    }

    return _module_references__title_fr.format(args) as unknown as string;
}

const _module_references__text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Faites comme des [slot="link"][b]milliers d’entreprises[/b][/slot]\nqui gagnent de nouveaux clients grâce à une meilleure visibilité digitale. Profitez\nde la puissance des nos fonctionnalités premium [b]au service de votre croissance[/b].',
        },
    ],
    'fr',
);

export function module_references__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_references__text_fr.format(args) as unknown as string;
    }

    return _module_references__text_fr.format(args) as unknown as string;
}

const _module_references__digital_visibility_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Plus de visibilité digitale ? Cliquez-ici !' }],
    'fr',
);

export function module_references__digital_visibility(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_references__digital_visibility_fr.format(
            args,
        ) as unknown as string;
    }

    return _module_references__digital_visibility_fr.format(args) as unknown as string;
}

const _module_tendances__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Tendances sur [b]Go Africa Online[/b]' }],
    'fr',
);

export function module_tendances__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_fr.format(args) as unknown as string;
    }

    return _module_tendances__title_fr.format(args) as unknown as string;
}

const _module_tendances__text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "[p]Professionnels, entreprises, salariés et étudiants d'Afrique, rejoignez le [b]réseau social professionnel[/b]\net profitez d’un espace d'échange, de partage d'idées, d’expertise et de\ncollaboration. Développez votre réseau, découvrez des opportunités d'affaires\net d'emploi, et restez à la pointe des tendances et des innovations sur le\ncontinent.[/p]\n[p]Rejoignez-nous pour façonner l'avenir professionnel de l'Afrique.[/p]",
        },
    ],
    'fr',
);

export function module_tendances__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__text_fr.format(args) as unknown as string;
    }

    return _module_tendances__text_fr.format(args) as unknown as string;
}

const _module_tendances__title_companies_fr = new IntlMessageFormat(
    [{ type: 0, value: '[b]Entreprises[/b] les plus suivies' }],
    'fr',
);

export function module_tendances__title_companies(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_companies_fr.format(args) as unknown as string;
    }

    return _module_tendances__title_companies_fr.format(args) as unknown as string;
}

const _module_tendances__title_publications_fr = new IntlMessageFormat(
    [{ type: 0, value: '[b]Publications[/b] les plus tendances' }],
    'fr',
);

export function module_tendances__title_publications(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_publications_fr.format(args) as unknown as string;
    }

    return _module_tendances__title_publications_fr.format(args) as unknown as string;
}

const _module_tendances__title_pros_fr = new IntlMessageFormat(
    [{ type: 0, value: '[b]Professionnels[/b] les plus suivis' }],
    'fr',
);

export function module_tendances__title_pros(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_pros_fr.format(args) as unknown as string;
    }

    return _module_tendances__title_pros_fr.format(args) as unknown as string;
}

const _module_tendances__join_free_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Rejoignez gratuitement des millions de membres et d’entreprises %ap%',
        },
    ],
    'fr',
);

export function module_tendances__join_free(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__join_free_fr.format(args) as unknown as string;
    }

    return _module_tendances__join_free_fr.format(args) as unknown as string;
}

const _module_tendances__register_fr = new IntlMessageFormat(
    [{ type: 0, value: "S'inscrire" }],
    'fr',
);

export function module_tendances__register(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__register_fr.format(args) as unknown as string;
    }

    return _module_tendances__register_fr.format(args) as unknown as string;
}

const _module_articles__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nos derniers [b]articles[/b]' }],
    'fr',
);

export function module_articles__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_articles__title_fr.format(args) as unknown as string;
    }

    return _module_articles__title_fr.format(args) as unknown as string;
}

const _module_articles__view_all_articles_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir tous les articles' }],
    'fr',
);

export function module_articles__view_all_articles(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_articles__view_all_articles_fr.format(args) as unknown as string;
    }

    return _module_articles__view_all_articles_fr.format(args) as unknown as string;
}
